import queryString from 'query-string'

const CREATE_PARTICIPANT = 'dofe-bo/participant/CREATE_PARTICIPANT'
const CREATE_PARTICIPANT_SUCCESS =
  'dofe-bo/participant/CREATE_PARTICIPANT_SUCCESS'
const CREATE_PARTICIPANT_FAIL = 'dofe-bo/participant/CREATE_PARTICIPANT_FAIL'

const CHECK_LEADER = 'dofe-bo/participant/CHECK_LEADER'
const CHECK_LEADER_SUCCESS = 'dofe-bo/participant/CHECK_LEADER_SUCCESS'
const CHECK_LEADER_FAIL = 'dofe-bo/participant/CHECK_LEADER_FAIL'

const GET_PAYMENT_OPTIONS = 'dofe-bo/participant/GET_PAYMENT_OPTIONS'
const GET_PAYMENT_OPTIONS_SUCCESS =
  'dofe-bo/participant/GET_PAYMENT_OPTIONS_SUCCESS'
const GET_PAYMENT_OPTIONS_FAIL = 'dofe-bo/participant/GET_PAYMENT_OPTIONS_FAIL'

const PAYMENT_INITIALIZATION = 'dofe-bo/participant/PAYMENT_INITIALIZATION'
const PAYMENT_INITIALIZATION_SUCCESS =
  'dofe-bo/participant/PAYMENT_INITIALIZATION_SUCCESS'
const PAYMENT_INITIALIZATION_FAIL =
  'dofe-bo/participant/PAYMENT_INITIALIZATION_FAIL'

const SEND_REG_CODE = 'dofe-bo/participant/SEND_REG_CODE'
const SEND_REG_CODE_SUCCESS = 'dofe-bo/participant/SEND_REG_CODE_SUCCESS'
const SEND_REG_CODE_FAIL = 'dofe-bo/participant/SEND_REG_CODE_FAIL'

const GET_REGISTRATION_OPTIONS = 'dofe-fo/participant/GET_REGISTRATION_OPTIONS'
const GET_REGISTRATION_OPTIONS_SUCCESS =
  'dofe-fo/participant/GET_REGISTRATION_OPTIONS_SUCCESS'
const GET_REGISTRATION_OPTIONS_FAIL =
  'dofe-fo/participant/GET_REGISTRATION_OPTIONS_FAIL'

const GET_REGISTRATION_INFO = 'dofe-bo/participant/GET_REGISTRATION_INFO'
const GET_REGISTRATION_INFO_SUCCESS = 'dofe-bo/participant/GET_REGISTRATION_INFO_SUCCESS'
const GET_REGISTRATION_INFO_FAIL = 'dofe-bo/participant/GET_REGISTRATION_INFO_FAIL'

const CREATE_PARTICIPANT_USING_AUTH_CODE = 'dofe-bo/participant/CREATE_PARTICIPANT_USING_AUTH_CODE'
const CREATE_PARTICIPANT_USING_AUTH_CODE_SUCCESS = 'dofe-bo/participant/CREATE_PARTICIPANT_USING_AUTH_CODE_SUCCESS'
const CREATE_PARTICIPANT_USING_AUTH_CODE_FAIL = 'dofe-bo/participant/CREATE_PARTICIPANT_USING_AUTH_CODE_FAIL'

const initialState = {
  loading: false,
  loaded: false,
  loadingOptions: false,
  loadedOptions: false,
  loadingRegistrationInfo: false,
  loadedRegistrationInfo: false,
  registrationInfo: {},
  paymentOptions: [],
  registrationOptions: {},
  filter: ''
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_PARTICIPANT:
      return {
        ...state,
        loading: true
      }
    case CREATE_PARTICIPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case CREATE_PARTICIPANT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_REGISTRATION_OPTIONS:
    case GET_PAYMENT_OPTIONS:
      return {
        ...state,
        loadingOptions: true
      }
    case GET_PAYMENT_OPTIONS_SUCCESS:
      return {
        ...state,
        loadingOptions: false,
        loadedOptions: true,
        paymentOptions: action.result
      }
    case GET_REGISTRATION_OPTIONS_FAIL:
    case GET_PAYMENT_OPTIONS_FAIL:
      return {
        ...state,
        loadingOptions: false,
        loadedOptions: false,
        error: action.error
      }
    case GET_REGISTRATION_OPTIONS_SUCCESS:
      return {
        ...state,
        loadingOptions: false,
        loadedOptions: false,
        registrationOptions: action.result
      }
    case GET_REGISTRATION_INFO:
      return {
        ...state,
        loadingRegistrationInfo: true
      }
    case GET_REGISTRATION_INFO_SUCCESS:
      return {
        ...state,
        loadingRegistrationInfo: false,
        loadedRegistrationInfo: true,
        registrationInfo: action.result || {}
      }
    case GET_REGISTRATION_INFO_FAIL:
      return {
        ...state,
        loadingRegistrationInfo: false,
        loadedRegistrationInfo: false,
        error: action.error
      }
    case CREATE_PARTICIPANT_USING_AUTH_CODE:
      return {
        ...state,
        loading: true
      }
    case CREATE_PARTICIPANT_USING_AUTH_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case CREATE_PARTICIPANT_USING_AUTH_CODE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function createParticipant(data) {
  return {
    types: [
      CREATE_PARTICIPANT,
      CREATE_PARTICIPANT_SUCCESS,
      CREATE_PARTICIPANT_FAIL
    ],
    promise: client =>
      client.post('api/participant-registrations/completion', {
        data,
        removeToken: true
      })
  }
}

export function checkLeader({ email, awardUnitId }) {
  return {
    types: [CHECK_LEADER, CHECK_LEADER_SUCCESS, CHECK_LEADER_FAIL],
    promise: client =>
      client.post(
        `api/participant-registrations/leader-by-email?organizationId=${encodeURIComponent(awardUnitId)}`,
        {
          removeToken: true,
          data: {
            value: email
          }
        }
      )
  }
}

export function sendRegistrationCode(email) {
  return {
    types: [SEND_REG_CODE, SEND_REG_CODE_SUCCESS, SEND_REG_CODE_FAIL],
    promise: client =>
      client.post('api/registration/send-registration-code', {
        data: {
          email
        }
      })
  }
}

export function getPaymentOptions({
  organizationId,
  awardLevel,
  isDirectLevelRegistration = true
}) {
  return {
    types: [
      GET_PAYMENT_OPTIONS,
      GET_PAYMENT_OPTIONS_SUCCESS,
      GET_PAYMENT_OPTIONS_FAIL
    ],
    promise: client =>
      client.get(
        'api/participant-registrations/payment-options?' +
          queryString.stringify({
            awardLevel,
            organizationId,
            isDirectLevelRegistration
          }),
        {
          removeToken: true
        }
      )
  }
}

export function getPaymentOptionsByAuthCode({ authorizationCode }) {
  return {
    types: [
      GET_PAYMENT_OPTIONS,
      GET_PAYMENT_OPTIONS_SUCCESS,
      GET_PAYMENT_OPTIONS_FAIL
    ],
    promise: client =>
      client.get(
        'api/participant-registrations/payment-options/using-authorization-code?' +
          queryString.stringify({
            authorizationCode
          }),
        {
          removeToken: true
        }
      )
  }
}

export function paymentInitialization(data) {
  return {
    types: [
      PAYMENT_INITIALIZATION,
      PAYMENT_INITIALIZATION_SUCCESS,
      PAYMENT_INITIALIZATION_FAIL
    ],
    promise: client =>
      client.post(
        'api/participant-registrations/online-payment-initialization',
        {
          removeToken: true,
          data
        }
      )
  }
}

export function getRegistrationOptions({
  organizationId,
  isDirectLevelRegistration = true,
  awardLevel,
  previousAwardLevel = undefined,
  registrationId = undefined
}) {
  return {
    types: [
      GET_REGISTRATION_OPTIONS,
      GET_REGISTRATION_OPTIONS_SUCCESS,
      GET_REGISTRATION_OPTIONS_FAIL
    ],
    promise: client =>
      client.get(
        'api/participant-registrations/configurations?' +
          queryString.stringify({
            organizationId,
            isDirectLevelRegistration,
            awardLevel,
            previousAwardLevel,
            registrationId
          })
      )
  }
}

export function getRegistrationInfo(code) {

  return {
    types: [GET_REGISTRATION_INFO, GET_REGISTRATION_INFO_SUCCESS, GET_REGISTRATION_INFO_FAIL],
    promise: client =>
      client.get(
        `api/participant-registrations/using-authorization-code?authorizationCode=${code}`,
        {
          removeToken: true
        }
      )
  }
}

export function createParticipantUsingAuthCode(authorizationCode, data) {
  return {
    types: [
      CREATE_PARTICIPANT_USING_AUTH_CODE,
      CREATE_PARTICIPANT_USING_AUTH_CODE_SUCCESS,
      CREATE_PARTICIPANT_USING_AUTH_CODE_FAIL
    ],
    promise: client =>
      client.post(
        `api/participant-registrations/completion/using-authorization-code?authorizationCode=${authorizationCode}`,
        {
          data,
          removeToken: true
        }
      )
  }
}
